// Prevent Details toggle on click for submenu items with children (desktop only)
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth >= 750) {
    document.querySelectorAll('details[id^="Details-HeaderSubMenu-"] > summary').forEach(function (summary) {
      summary.addEventListener('click', function (e) {
        e.preventDefault();
      });
    });
  }
});

// Keep the mobile sticky bar price in sync with the selected variant
(function () {
  function syncStickyPrice(variantId) {
    var select = document.getElementById('productSelect-sticky');
    var priceEl = document.querySelector('#sticky-atc .stic_price');
    if (!select || !priceEl) return;
    if (!variantId) {
      var idInput = document.querySelector('.form .product-variant-id');
      variantId = idInput && idInput.value;
    }
    if (!variantId) return;
    var opt = select.querySelector('option[value="' + variantId + '"]');
    if (!opt) return;
    select.value = variantId;
    priceEl.textContent = opt.getAttribute('custom_price');
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      syncStickyPrice(e && e.data && e.data.variant && e.data.variant.id);
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-selects, variant-radios')) {
      setTimeout(function () { syncStickyPrice(); }, 300);
    }
  });
})();

// Hide main header on scroll down, show on scroll up
(function () {
  var lastY = window.scrollY;
  var root = document.documentElement;

  function setHeaderHeight() {
    var h = document.querySelector('.header-wrapper > header');
    if (h) root.style.setProperty('--gz-header-h', h.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (Math.abs(y - lastY) < 5) return;
        var menuOpen = document.querySelector('.header-wrapper details[open]:not([id^="Details-HeaderSubMenu-"])');
    if (y > lastY && y > 150 && !menuOpen) {
      root.classList.add('gz-header-hidden');
    } else if (y < lastY || y <= 150) {
      root.classList.remove('gz-header-hidden');
    }
    lastY = y;
  }, { passive: true });
})();
// Mega menu: keep third-level lists (e.g. Shop All) open on desktop
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 990) return;
  document.querySelectorAll('.header__inline-menu details[id^="Details-HeaderSubMenu-"]').forEach(function (d) {
    d.open = true;
    d.addEventListener('toggle', function () {
      if (!d.open && window.innerWidth >= 990) d.open = true;
    });
  });
});

// Collection pages: start content directly below the header, tabs and filter bar
(function () {
  var root = document.documentElement;
  function setTopOffset() {
    if (!document.body.classList.contains('collection')) return;
    var wrap = document.querySelector('sticky-header.header-wrapper');
    var filters = document.getElementById('main-collection-filters');
    var h = wrap ? wrap.offsetHeight : 0;
    if (filters && getComputedStyle(filters).position === 'fixed') h += filters.offsetHeight - 1;
    root.style.setProperty('--gz-top-offset', h + 'px');
  }
  setTopOffset();
  window.addEventListener('resize', setTopOffset);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(setTopOffset);
    var w = document.querySelector('sticky-header.header-wrapper');
    var f = document.getElementById('main-collection-filters');
    if (w) ro.observe(w);
    if (f) ro.observe(f);
  }
})();